import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/apt/diagnose/error.tsx");
